export default __webpack_public_path__ + "static/theescaperoomer-e40e6f5b8373135a797981dce501a3a9.png";